import { render, staticRenderFns } from "./CommissionerUser.vue?vue&type=template&id=274c57f8&"
import script from "./CommissionerUser.vue?vue&type=script&lang=js&"
export * from "./CommissionerUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports